import { useVerifyInvitationCompany } from "./_hooks/use-verify-invitation";

export const AuthInvitationVerifyPage = () => {
	useVerifyInvitationCompany();

	return <></>;
};
